// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Bz3d","image":"Header_image__8OkOC","name":"Header_name__1cFFb","info":"Header_info__X3ydh","infoRow":"Header_infoRow__3unai"};